<template>
	<div class="fuel container-fluid py-4"> <!--  v-if="plant.PlantNo" -->
		<div class="row">
			<div class="col-md-12 mb-3">
				<el-tag style="width:100vw;font-size:20px;padding-top:10px;padding-bottom:10px;white-space: normal;display: table-cell;"><strong>{{plant.BOSStationId }} - {{plant.StationName}}</strong></el-tag>
			</div>
		</div>
		<div class="row">
			<PlantStationDetail :plant="plant.PlantNo" :station="plant.StationId" />
		</div>
		<Footer/>
	</div>
</template>

<script>
import Plant from '@/components/page/Plant.js'
//import PlantSatgas2 from '@/views/pages/PlantSatgas2.vue'
import PlantStationDetail from '@/views/pages/PlantStationDetail.vue'
import Footer from '@/views/Footer.vue'
import {  Config, AxiosWithJar } from '@/utility.js'

export default{
	extends: Plant,
	components:{
		//PlantSatgas2,	
		PlantStationDetail,		
		Footer
	},
	computed:{
	},
    mounted(){
		this.$nextTick(function(){
			this.loadPlantStation(this.$route.query.plant, this.$route.query.station);		
		})
    },
	/*
	updated() {
		this.$nextTick(function() {
			this.loadPlantSatgas(this.$route.query.plant, this.$route.query.station);
		})
	},
	*/
    methods:{

        async loadPlantStation(plant, station) {
			let url = Config().apiURL + "/v1/plant/plantStation?" + (plant ? "&plantno=" + plant : "") + (station ? "&stationid=" + station : "");
			await AxiosWithJar().get(url).then(result=>{
				if(result.data.length){
					this.plant = result.data[0];
				}
			})
		},

	}
}

</script>